import { StreamingStatusDTO } from 'core/streamingStatus/StreamingStatus';
import client from './RestClient';
import { AxiosInstance } from 'axios';

export interface StreamingStatusWebService {
  getStreamingStatusList(): Promise<StreamingStatusDTO[]>;
  updateStreamingStatus(crid: number | '', isLive: boolean): Promise<void>;
}

export class RestfulStreamingStatusWebService implements StreamingStatusWebService {
  restClient: AxiosInstance;

  constructor(restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  async getStreamingStatusList(): Promise<StreamingStatusDTO[]> {
    const response = await this.restClient.get('/streaming/status');
    return response.data.records;
  }

  async updateStreamingStatus(
    crid: number | '',
    isLive: boolean
  ): Promise<void> {
    await this.restClient.post(
      `/streaming/status?crid=${encodeURIComponent(crid)}&isLive=${isLive}`
    );
  }
}
